import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as GA from './global-account.component';
import * as SL from './signup-login.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule
	],
	declarations: [
		GA.GlobalAccountComponent,
		GA.GlobalAccountIntroDialog,
		GA.GlobalAccountCompleteDialog,
		GA.GlobalLoginComponent,
		GA.GlobalSignupComponent,
		SL.SignupLoginDialog,
		SL.SignupLoginComponent,
		SL.LoginComponent,
		SL.SignupComponent,
		SL.ResetPasswordComponent
	],
	exports: [
		GA.GlobalAccountComponent,
		GA.GlobalAccountIntroDialog,
		GA.GlobalAccountCompleteDialog,
		GA.GlobalLoginComponent,
		GA.GlobalSignupComponent,
		SL.SignupLoginDialog,
		SL.SignupLoginComponent,
		SL.LoginComponent,
		SL.SignupComponent,
		SL.ResetPasswordComponent
	]
})
export class SignupLoginComponentModule { }
